import { useContext } from 'react'

export default function useCtx(key) {
  return useContext(ctx(key))
}
